import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import carInterior from "./components/car-interior";
import soundPressure from "./components/sound-pressure";
import soundReflection from "./components/sound-reflection";
import screenDiffraction from "./components/screen-diffraction";

const principle: Slide = {
  description:
    "Here we show some exaples of numerical simualtions, click on the buttons below to see the different examples and explanations.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Car interior<br>sound field (FEM)" },
            { name: "Sound pressure<br>at human pinna (BEM)" },
            { name: "Sound reflection<br>in a room (FDTD)" },
            { name: "Screen Diffraction<br>(FDTD)" },
          ],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], [], []],
      components: [carInterior, soundPressure, soundReflection, screenDiffraction],
    },
  },
};

export default principle;
